import { getPassedTime } from "../../../js/modules/functions";
import { UsernameWithBadge } from "../shared/username-with-badge";
import { useActivityFeed } from "./activity-feed";
import { ActivityHubAvatar } from "./activity-hub-avatar";

/**
 * Every handle in the feed renders through the shared badge component (T212588) so an
 * influencer is marked here exactly as they are on cards and profile pages.
 */
function FeedHandle({ member }) {
  return (
    <UsernameWithBadge
      username={member.name ?? member.umbracoUserId}
      profileUrl={member.profileUrl}
      badge={member.badge}
      prefixWithAt
      nameClassName="activity-feed-group-item__collection-name"
    />
  );
}

function getActivityTextAction({ activityType, targetMember }) {
  const {
    liked,
    likedYourCollection,
    startedFollowing,
    startedFollowingYou,
    sharedCollection,
  } = useActivityFeed();
  switch (activityType) {
    case 1:
      return liked;
    case 2:
      return targetMember?.isCurrentUser ? likedYourCollection : liked;
    case 3:
      return targetMember && !targetMember.isCurrentUser
        ? startedFollowing
        : startedFollowingYou;
    case 4:
      return sharedCollection;
    default:
      return "";
  }
}

function ActivityGroupItemStatusTextTarget({
  activityType,
  colours,
  targetMember,
  collection,
}) {
  const { multipleColours, colourCollection } = useActivityFeed();

  switch (activityType) {
    case 1:
      if (colours.length > 1) {
        return <span>{multipleColours}</span>;
      } else if (colours[0]?.url) {
        return (
          <a
            class="activity-feed-group-item__collection-name"
            href={colours[0].url}
          >
            {colours[0].name}
          </a>
        );
      } else {
        return <span>{colours[0]?.name}</span>;
      }
    case 2:
      if (targetMember?.isCurrentUser) {
        return (
          <a
            className="activity-feed-group-item__collection-name"
            href={collection.collectionUrl}
          >
            {collection.name}
          </a>
        );
      } else if (targetMember) {
        return (
          <>
            <FeedHandle member={targetMember} />
            {colourCollection}{" "}
            <a
              className="activity-feed-group-item__collection-name"
              href={collection.collectionUrl}
            >
              {collection.name}
            </a>
          </>
        );
      } else {
        return (
          <a
            className="activity-feed-group-item__collection-name"
            href={collection.collectionUrl}
          >
            {collection.name}
          </a>
        );
      }
    case 3:
      if (targetMember && !targetMember.isCurrentUser) {
        return <FeedHandle member={targetMember} />;
      }
      break;
    case 4:
      return (
        <a
          className="activity-feed-group-item__collection-name"
          href={collection.collectionUrl}
        >
          {collection.name}
        </a>
      );
  }
}

function ActivityGroupItemStatusText({
  actor,
  colours,
  targetMember,
  collection,
  activityType,
}) {
  const action = getActivityTextAction({ activityType, targetMember });

  return (
    <p className="activity-feed-group-item__text">
      <UsernameWithBadge
        username={actor.name ?? actor.umbracoUserId}
        profileUrl={actor.profileUrl}
        badge={actor.badge}
        prefixWithAt
        nameClassName="activity-feed-group-item__user-name"
      />{" "}
      {action}{" "}
      <ActivityGroupItemStatusTextTarget
        activityType={activityType}
        colours={colours}
        targetMember={targetMember}
        collection={collection}
      />
    </p>
  );
}

export const ActivityGroupItemStatus = ({ activityData }) => {
  const { justNow, minsAgo, hoursAgo, daysAgo } = useActivityFeed();
  const { activityType, actor, timestamp, targetMember, collection, colours } =
    activityData;

  return (
    <>
      <ActivityHubAvatar
        isLiked={[1, 2].includes(activityType)}
        imgUrl={actor.imageUrl}
      />
      <div className="activity-feed-group-item__text-wrapper">
        <ActivityGroupItemStatusText
          actor={actor}
          colours={colours}
          targetMember={targetMember}
          collection={collection}
          activityType={activityType}
        />
        <p className="activity-feed-group-item__time">
          {getPassedTime({
            timestamp,
            justNow,
            minsAgo,
            hoursAgo,
            daysAgo,
          })}
        </p>
      </div>
    </>
  );
};
